<template>
  <div class="mydialog big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      :destroy-on-close="true"
    >
      <div style="min-height: 500px; max-height: 700px">
        <video
          :src="preUrl"
          controls="controls"
          v-if="isvideo"
          style="width: 100%; max-height: 650px"
        >
          您的浏览器不支持视频播放
        </video>
        <img
          :src="preUrl"
          alt
          v-else
          style="width: 100%; max-height: 650px"
        />
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="upload"
      width="600px"
      title="上传视频及封面
"
      class="mydia"
    >
      <div class="imgbox">
        <div class="uploadimg">
          <el-upload
            name="image"
            accept=".mp4"
            :action="uploadUrl"
            :data="uploadExtraData"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="
              (res, file, fileList) => {
                return handleAvatarSuccess(res, file, fileList, 1);
              }
            "
            :before-upload="
              (file) => {
                return beforeAvatarUpload(file, 1);
              }
            "
          >
            <video
              v-if="video_path"
              :src="video_path"
              controls="controls"
              class="avatar"
            >
              您的浏览器不支持视频播放
            </video>
            <div
              v-else
              class="uploader-icon"
            >
              <div>
                <i
                  class="el-icon-plus"
                  style="font-size: 25px"
                ></i>
              </div>
              <el-button
                type="text"
                size="medium"
              >添加视频</el-button>
              <div style="color: #b0babc; font-size: 12px">
                视频格式只支持mp4,长度限制15s-100s
              </div>
            </div>
          </el-upload>
        </div>
        <div class="uploadimg">
          <el-upload
            name="image"
            accept=".png,.jpeg,.jpg"
            :action="uploadUrl"
            :data="uploadExtraData"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="
              (res, file, fileList) => {
                return handleAvatarSuccess(res, file, fileList, 0);
              }
            "
            :before-upload="
              (file) => {
                return beforeAvatarUpload(file, 0);
              }
            "
          >
            <img
              v-if="main_path"
              :src="main_path"
              class="avatar"
            />
            <div
              v-else
              class="uploader-icon"
            >
              <div>
                <i
                  class="el-icon-plus"
                  style="font-size: 25px"
                ></i>
              </div>
              <el-button
                type="text"
                size="medium"
              >添加图片</el-button>
              <div style="color: #b0babc; font-size: 12px">
                支持jpg、png、jpeg格式
              </div>
            </div>
          </el-upload>
        </div>
      </div>
      <div style="padding-bottom: 20px">
        <el-button
          type="primary"
          size="medium"
          style="width: 92px"
          @click="sumbit"
        >提交</el-button>
      </div>
    </el-dialog>
    <div class="page_title">审核视频</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div>
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo noneline"
              mode="horizontal"
              @select="handleSelect"
            >
              <el-menu-item
                index="0"
                class="title"
                style="font-size: 16px"
              >全部</el-menu-item>
              <el-menu-item
                index="1"
                class="title space"
                style="font-size: 16px"
              >未提交</el-menu-item>
              <el-menu-item
                index="2"
                class="title"
                style="font-size: 16px"
              >审核中</el-menu-item>
              <el-menu-item
                index="3"
                class="title"
                style="font-size: 16px"
              >审核通过</el-menu-item>
              <el-menu-item
                index="4"
                class="title"
                style="font-size: 16px"
              >审核不通过</el-menu-item>
            </el-menu>
          </div>
          <div class="box">
            <div class="searchbox">
              <div>
                <span>医生姓名</span>
                <el-input
                  v-model="doctorName"
                  style="width: 160px; margin: 0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <span>手机号</span>
                <el-input
                  v-model="doctorPhone"
                  style="width: 160px; margin: 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <el-button
                  type="info"
                  style="background-color: #eceff2; color: #747981"
                  @click="search"
                >查询</el-button>
              </div>
              <el-button
                type="primary"
                @click="examineAll"
                style="width: 120px"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('33') : false
                "
              >批量审核</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection"></el-table-column>

                <el-table-column label="医生头像">
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.head_img"
                      alt
                      style="width: 40px; height: 40px"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  label="医生姓名"
                  prop="doctor_name"
                >
                  <template slot-scope="scope">
                    <span
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor:pointer"
                    >{{ scope.row.doctor_name }}</span>
                    <span
                      v-if="scope.row.sex == 1"
                      style="margin-left: 16px"
                    >男</span>
                    <span
                      v-if="scope.row.sex == 2"
                      style="margin-left: 16px"
                    >女</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="手机号"
                  prop="phone"
                ></el-table-column>

                <el-table-column label="视频审核状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">未提交</span>
                    <span
                      v-if="scope.row.status == 2"
                      style="color: #669961"
                    >审核中</span>
                    <span v-if="scope.row.status == 3">审核通过</span>
                    <span
                      v-if="scope.row.status == 4"
                      style="color: #d0523c"
                    >审核不通过</span>
                  </template>
                </el-table-column>

                <el-table-column label="视频">
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.video_url"
                      class="videobox"
                      @click="imgpre(scope.row.video_url, 1)"
                    >
                      <img
                        :src="scope.row.mian_url"
                        alt
                        class="videoimg"
                      />
                      <img
                        :src="video_on"
                        alt
                        class="onvideo"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="视频封面">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.mian_url"
                      :src="scope.row.mian_url"
                      alt
                      style="width: 100px; height: 70px; cursor: pointer"
                      @click="imgpre(scope.row.mian_url, 0)"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.doctor_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('31')
                          : false
                      "
                    >查看详情</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.status == 2"
                      @click="examine(scope.row.doctor_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('33')
                          : false
                      "
                    >审核</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.status == 1"
                      @click="uploadImg(scope.row.doctor_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('34')
                          : false
                      "
                    >上传</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.status == 3 || scope.row.status == 4"
                      @click="delvideo(scope.row.doctor_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('35')
                          : false
                      "
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doctor from '../../../api/doctor';
import constant from '../../../service/common/constant';
import DocMsg from '../../../components/common/DocMsg.vue';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      Selection: [],
      activeIndex: '0',
      active: 0,
      doctorName: '',
      doctorPhone: '',
      video_on: require('@/assets/img/video.svg'),
      dialogVisible: false,
      isvideo: 0,
      preUrl: '',
      uploadExtraData: {
        img_type: 1,
        suffix: '.jpg'
      },
      upload: false,
      videoUrl: '',
      mianUrl: '',
      video_path: '',
      main_path: '',
      doctorId: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctorName,
        doctor_phone: this.doctorPhone,
        auth_status: this.active
      };
      doctor
        .videoAuthList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelect(key) {
      this.doctorName = '';
      this.doctorPhone = '';
      this.active = key;
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChange(val) {
      this.Selection = val;
    },
    //上传按钮
    uploadImg(doctor_id) {
      this.upload = true;
      this.doctorId = doctor_id;
    },
    //提交视频
    sumbit() {
      if (!this.videoUrl || !this.mianUrl) {
        this.$message.error('请上传视频和主图!');
        return false;
      }
      let data = {
        doctor_id: this.doctorId,
        video_url: this.videoUrl,
        mian_url: this.mianUrl
      };
      doctor
        .submitDoctorVideo(data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('上传成功');
            this.upload = false;
            this.getList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //上传成功 0主图1视频
    handleAvatarSuccess(res, file, fileList, type) {
      if (res.code === 0) {
        if (type) {
          this.videoUrl = res.data.pic;
          this.video_path = res.data.path;
        } else {
          this.mianUrl = res.data.pic;
          this.main_path = res.data.path;
        }
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    beforeAvatarUpload(file, type) {
      if (type) {
        //上传视频
        const supportImgTypes = ['video/mp4'];
        const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isSupportType) {
          this.$message.error('上传视频只能是 mp4格式!');
        }
        if (!isLt100M) {
          this.$message.error('上传视频大小不能超过 100MB!');
        }
        const suffix = file.name.substring(file.name.lastIndexOf('.'));
        this.uploadExtraData.suffix = suffix;
        this.uploadExtraData.img_type = 3;
        this.uploadHeaders.timestamp = Date.now();
        return isSupportType && isLt100M;
      } else {
        const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
        if (!isSupportType) {
          this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
          return false;
        }
        const suffix = file.name.substring(file.name.lastIndexOf('.'));
        this.uploadExtraData.suffix = suffix;
        this.uploadExtraData.img_type = 4;
        this.uploadHeaders.timestamp = Date.now();
        const _this = this;
        return new Promise((resolve) => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = 750;
            const height = (750 / image.width) * image.height;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoFile(dataUrl, file.name);
            resolve(blobData);
          };
          reader.onload = (e) => {
            image.src = e.target.result;
          };
          reader.readAsDataURL(file);
        });
      }
    },

    //视频图片预览
    imgpre(url, status) {
      this.preUrl = url;
      this.isvideo = status;
      this.dialogVisible = true;
    },
    //医生详情
    toDetail(doctor_id) {
      this.$router.push({ path: 'doctordetail', query: { doctor_id } });
    },
    //审核
    examine(doctor_id) {
      this.$confirm('是否审核通过？', '审核', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过'
      })
        .then(() => {
          let auth_status = 2;
          doctor.auditVideo({ doctor_id, auth_status }).then((res) => {
            if (res.code == 0) {
              this.$message.success('该视频审核通过!');
            }
            this.getList();
          });
        })
        .catch((action) => {
          if (action === 'cancel') {
            let auth_status = 3;
            doctor.auditVideo({ doctor_id, auth_status }).then((res) => {
              if (res.code == 0) {
                this.$message.error('该视频审核未通过!');
              }
              this.getList();
            });
          }
        });
    },
    //批量审核
    examineAll() {
      if (!this.Selection.length) {
        this.$message.error("请勾选'审核中'的记录");
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.doctor_id;
      });
      let doctor_id = selectId.toString();
      this.examine(doctor_id);
    },
    //删除
    delvideo(doctor_id) {
      this.$confirm('确定删除视频吗？删除后不可恢复', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          doctor
            .deleteVideo({ doctor_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getList();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>